import styled from 'styled-components';
import { th } from 'style/theme';
import { sizes } from 'style';

export const StyledSection = styled.div`
  margin-bottom: 40px;
`;

export const SectionTitle = styled.div`
  margin-top: 22px;
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: bold;
  color: ${th('colors.turquoise')};

  @media ${sizes.tabletPortrait} {
    margin-top: 40px;
    margin-bottom: 22px;
  }
`;

export const SectionContent = styled.div`
  > * {
    margin: 0;
    &:not(:last-child) {
      margin-bottom: 20px;
    }
  }
`;

export const StyledSubSection = styled.div`
  margin-bottom: ${({ showAnswer }) => (showAnswer ? '40px' : '20px')};

  @media ${sizes.desktop} {
    margin-bottom: ${({ showAnswer }) => (showAnswer ? '60px' : '30px')};
  }

  > * {
    margin: 0;
    &:not(:last-child) {
      margin-bottom: 20px;
    }
  }
`;

export const SubsectionTitle = styled.div`
  display: flex;
  font-weight: bold;
  cursor: pointer;

  > svg {
    flex-shrink: 0;
    margin-top: 2px;
    margin-right: 4px;
    font-size: 23px;
    color: ${th('colors.turquoise')};
    filter: ${({ showAnswer }) =>
      showAnswer
        ? 'drop-shadow(0px -1px 1px #00000029)'
        : 'drop-shadow(0px 1px 1px #00000029)'};
    transition: transform 0.2s;
    transform: ${({ showAnswer }) => (showAnswer ? 'rotate(180deg)' : 'rotate(0deg)')};
  }
`;

export const CostCoverage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media ${sizes.tabletPortrait} {
    flex-direction: row;
    align-items: flex-start;
  }

  > * {
    flex: 1;
  }
`;

export const SWCovers = styled.div`
  padding: 12px;
  border-radius: 10px;
  border: 1px solid ${th('colors.blue')};
  font-size: 14px;
  line-height: 24px;
  background-color: ${th('colors.blue')}33;
`;

export const YouCover = styled.div`
  padding: 12px;
  border-radius: 10px;
  border: 1px solid ${th('colors.orange')};
  font-size: 14px;
  line-height: 24px;
  background-color: ${th('colors.orange')}33;
`;
